var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "serverManageList" } }, [
            _vm._v(" " + _vm._s(_vm.$t("serverManagement")) + " ")
          ]),
          _c("el-menu-item", { attrs: { index: "kickPlayerOffline" } }, [
            _vm._v(" " + _vm._s(_vm.$t("whitelistManagement")) + " ")
          ]),
          _c("el-menu-item", { attrs: { index: "kickPlayerOutLine" } }, [
            _vm._v(" " + _vm._s(_vm.$t("kickPlayerOffline")) + " ")
          ])
        ],
        1
      ),
      _c("kickPlayerOffline", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "kickPlayerOffline",
            expression: "activeIndex == 'kickPlayerOffline'"
          }
        ],
        ref: "kickPlayerOffline"
      }),
      _c("serverManageList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "serverManageList",
            expression: "activeIndex == 'serverManageList'"
          }
        ],
        ref: "serverManageList"
      }),
      _c("kickPlayerOutLine", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "kickPlayerOutLine",
            expression: "activeIndex == 'kickPlayerOutLine'"
          }
        ],
        ref: "kickPlayerOutLine"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }